// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1H5eG","filesListContainer":"PosDisputesFiles_filesListContainer__3JLjt","filesButton":"PosDisputesFiles_filesButton__2HCaj"};